"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplitudeAssignmentService = exports.FLAG_TYPE_HOLDOUT_GROUP = exports.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP = exports.DAY_MILLIS = void 0;
const hash_1 = require("../util/hash");
exports.DAY_MILLIS = 24 * 60 * 60 * 1000;
exports.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP = 'mutual-exclusion-group';
exports.FLAG_TYPE_HOLDOUT_GROUP = 'holdout-group';
class AmplitudeAssignmentService {
    constructor(amplitude, assignmentFilter) {
        this.amplitude = amplitude;
        this.assignmentFilter = assignmentFilter;
    }
    track(assignment) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.assignmentFilter.shouldTrack(assignment)) {
                this.amplitude.logEvent(this.toEvent(assignment));
            }
        });
    }
    toEvent(assignment) {
        const event = {
            event_type: '[Experiment] Assignment',
            user_id: assignment.user.user_id,
            device_id: assignment.user.device_id,
            event_properties: {},
            user_properties: {},
        };
        for (const resultsKey in assignment.results) {
            event.event_properties[`${resultsKey}.variant`] =
                assignment.results[resultsKey].value;
        }
        const set = {};
        const unset = {};
        for (const resultsKey in assignment.results) {
            if (assignment.results[resultsKey].type == exports.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP) {
                continue;
            }
            else if (assignment.results[resultsKey].isDefaultVariant) {
                unset[`[Experiment] ${resultsKey}`] = '-';
            }
            else {
                set[`[Experiment] ${resultsKey}`] =
                    assignment.results[resultsKey].value;
            }
        }
        event.user_properties['$set'] = set;
        event.user_properties['$unset'] = unset;
        event.insert_id = `${event.user_id} ${event.device_id} ${(0, hash_1.hashCode)(assignment.canonicalize())} ${Math.floor(assignment.timestamp / exports.DAY_MILLIS)}`;
        return event;
    }
}
exports.AmplitudeAssignmentService = AmplitudeAssignmentService;
